import "./footer.css";

const Footer = () => {
  return (
    <footer id="contact" className="footer-section">
      <div className="footer-container">
        <div className="footer-top">
          {/* Brand Section */}
          <div className="brand-section">
            <h4>About SVGOLD</h4>
            <div className="content">
              <p>
                About Us Satish Vaidya (SVGOLD) is a trusted gold jewellery
                manufacturer in Mumbai since 1992, with a legacy of fine
                craftsmanship spanning over two generations. We specialize in
                Mangalsutras, Necklaces, Custom Gold & Silver Jewellery, and
                offer both handmade jewellery and CAD casting jewellery to
                deliver precision, creativity, and timeless designs. With a
                reputation for quality and affordability, we proudly supply
                leading jewellers with exclusive, high-quality ornaments crafted
                to perfection.
              </p>
            </div>
          </div>

          {/* Contact Section */}
          <div className="contact-section">
            <h4>Contact Details:</h4>
            <div className="content">
              <p>
                Room no. 8, 1st Floor, 143 Ebrahim Mansion, Dr. Viegas Street,
                Kalbadevi Road, Mumbai 400 002
              </p>

              <p>
                Call: <a href="tel:+919004274008">+91 9004274008</a>
              </p>
              <p>
                WhatsApp:{" "}
                <a href="https://wa.me/918655981117">+91 8655981117</a>
              </p>
              <p>
                Email:{" "}
                <a href="mailto:satishvaidya007@gmail.com">
                  satishvaidya007@gmail.com
                </a>
              </p>
            </div>
          </div>

          {/* Map Section */}
          <div className="map-section">
            <h4>Visit Now</h4>
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3773.6090746729037!2d72.82594357466208!3d18.948690055958007!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7cf4f0247395f%3A0xfffbdbc397acfc94!2sVaidya%20Jewellers!5e0!3m2!1sen!2sin!4v1736792515541!5m2!1sen!2sin"
                width="100%"
                height="250"
                style={{
                  border: "0",
                  borderRadius: "8px",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Google Map"
              ></iframe>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="img-container">
            <img src="/images/SV-logo2.png" alt="" />
          </div>
          <p>
            © 2025 Satish Vaidya (SVGOLD) | Leading Gold & Silver Jewellery
            Manufacturer in Mumbai | All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
